import { EMPTY_LIST } from '../../../../../../constants/common'
import { getItemsIds } from '../../../../../../utils/common'
import { REQUEST_PROFILE_WIDGET_EDIT_LABEL_FIELD_NAME_LABELS } from '../../RequestProfileWidgetLabels.constants'

export function getRemainingLabelsPayload({ labels, removedLabelId }) {
  return {
    [REQUEST_PROFILE_WIDGET_EDIT_LABEL_FIELD_NAME_LABELS]: {
      label_ids: getItemsIds(labels || EMPTY_LIST).filter(
        id => id !== removedLabelId
      ),
    },
  }
}
